import "./DataAppendix.css";

const FREE_ITEMS = [
  "Monthly index values, January 2000 to June 2026",
  "Fixed 2000–2024 baseline (mean = 100, SD = 1)",
  "Full method and revision notes",
];

function DataAppendix() {
  return (
    <>
      {/* ACCESS PLANS — FREE only */}
      <section className="appendix-plans">
        <div className="appendix-card">

          <div className="appendix-eyebrow">
            On this page
          </div>

          <div className="appendix-title">
            The published series, January 2000 to June 2026
          </div>

          <p className="appendix-text">
            The monthly index covers January 2000 to June 2026, standardised
            over the fixed 2000–2024 baseline (mean = 100, SD = 1) so
            historical values stay comparable as new months are added. Read
            it here, reuse it with attribution, and check every point against
            the method, which is published in full.
          </p>

          <div className="appendix-items">
            {FREE_ITEMS.map((item) => (
              <div className="appendix-item" key={item}>
                <span>·</span>
                <span>{item}</span>
              </div>
            ))}
          </div>

        </div>
      </section>


      {/* CTA */}
      <section className="appendix-cta">

        <div className="appendix-cta-circle-one" />
        <div className="appendix-cta-circle-two" />

        <div className="appendix-cta-content">

          <div className="appendix-cta-text">
            <div className="appendix-cta-title">
              Using the series in your own research?
            </div>

            <p className="appendix-cta-paragraph">
              Tell us about your project. We are glad to hear how the index is
              used and open to research cooperation.
            </p>
          </div>

          <a href="./Contact.dc.html" className="appendix-cta-button">
            <span>Contact us</span>
            <span className="appendix-cta-arrow">→</span>
          </a>

        </div>

      </section>
    </>
  );
}

export default DataAppendix;